import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EngineTabTypes } from '../../search-engine/models/engine-tab-types.enum';
import { GroupAirportsPipe } from '../../search-engine/pipes/group-airports.pipe';
import { SharedModule } from '../../shared/shared.module';
import { HolidaySearchComponent } from '../holiday/holiday-search-page/holiday-search.component';


const routes: Routes = [
  {
    data: {name: 'Proposte', type: EngineTabTypes.Tour, canNavigate: false},
    path: '',
    //pathMatch: 'full',
    loadChildren: () => import('../../../modules/pages/proposte-page/proposte-page.module').then(m => m.PropostePageModule)
  },
  {
    data: {name: 'Ricerca Tour', type: EngineTabTypes.Tour, canNavigate: false},
    path: 'ricerca/:destinationId/:airportId/destinazione/:destinationName/aeroporto/:airportName/il/:departureDate/eta/:ages',
    component: HolidaySearchComponent
  },
  {
    data: {name: 'Dettaglio Tour', type: EngineTabTypes.Tour, canNavigate: false},
    path: 'dettaglio',
    loadChildren: () => import('./../holiday/holiday-detail-page/holiday-detail-page.module').then(m => m.HolidayDetailPageModule)
  },
  {
    data: {name: 'Booking Tour', type: EngineTabTypes.Tour, canNavigate: false},
    path: 'booking',
    loadChildren: () => import('./../holiday/holiday-booking-page/holiday-booking-page.module').then(m => m.HolidayBookingPageModule)
  }
]

@NgModule({
  declarations: [],
  imports: [SharedModule, RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [GroupAirportsPipe],
})
export class TourModule {}
